var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"\nut-circle-img ut-flex ut-items-center justify-center",class:{ 'vendor-avatar-small': _vm.small, 'vendor-avatar' : !_vm.small }},[_c('span',[_vm._v(_vm._s(_vm.strValue))])])}
var staticRenderFns = []

export { render, staticRenderFns }